export function buildIdentifierRows(identifiers, expectedIdentifierTypes) {
	const rows = identifiers.map(identifier => ({
		rowKey: `identifier-${identifier.Id}`,
		Id: identifier.Id,
		Type: {
			Code: identifier.Type.Code
		},
		Value: normalizeIdentifierValue(identifier.Value),
		IsActive: identifier.IsActive,
		OriginalIsActive: identifier.IsActive,
		isExpectedMissing: false,
		isPlaceholderExpected: false,
		isNew: false
	}));

	return applyExpectedIdentifierRows(rows, expectedIdentifierTypes);
}

export function applyExpectedIdentifierRows(rows, expectedIdentifierTypes) {
	const expectedTypeCodes = new Set(expectedIdentifierTypes.map(type => type.Code));
	const enrichedRows = rows.map(row => ({
		...row,
		isExpectedType: expectedTypeCodes.has(row.Type?.Code)
	}));

	for(const expectedType of expectedIdentifierTypes) {
		const hasExpectedValue = enrichedRows.some(row =>
			row.Type?.Code === expectedType.Code
				&& row.IsActive
				&& hasIdentifierText(row.Value)
		);

		if(!hasExpectedValue) {
			enrichedRows.push({
				rowKey: `expected-missing-${expectedType.Code}`,
				Type: {
					Code: expectedType.Code
				},
				Value: "",
				IsActive: true,
				OriginalIsActive: false,
				isExpectedType: true,
				isExpectedMissing: true,
				isPlaceholderExpected: true,
				isNew: true
			});
		}
	}

	return enrichedRows;
}

export function createIdentifierDraftRow(rowKey) {
	return {
		rowKey,
		Type: {
			Code: undefined
		},
		Value: "",
		IsActive: true,
		OriginalIsActive: false,
		isExpectedType: false,
		isExpectedMissing: false,
		isPlaceholderExpected: false,
		isNew: true,
		isCreateRow: true
	};
}

export function isIdentifierDraftRowBlank(row) {
	return row?.isCreateRow
		&& !hasIdentifierText(row.Type?.Code)
		&& !hasIdentifierText(row.Value);
}

export function isIdentifierDraftRowComplete(row) {
	return row?.isCreateRow
		&& hasIdentifierText(row.Type?.Code)
		&& hasIdentifierText(row.Value);
}

export function reconcileIdentifierDraftRows(rows, changedRowKey, createDraftRow) {
	const reconciledRows = [...rows];
	const changedRowIndex = reconciledRows.findIndex(row => row.rowKey === changedRowKey);
	const changedRow = reconciledRows[changedRowIndex];

	if(changedRow?.isCreateRow
		&& !hasIdentifierText(changedRow.Value)
		&& reconciledRows
			.slice(changedRowIndex + 1)
			.some(isIdentifierDraftRowBlank)) {
		reconciledRows.splice(changedRowIndex, 1);
	}

	const hasIncompleteDraftRow = reconciledRows.some(row =>
		row.isCreateRow && !isIdentifierDraftRowComplete(row)
	);
	if(!hasIncompleteDraftRow) {
		reconciledRows.push(createDraftRow());
	}

	return reconciledRows;
}

export function normalizeIdentifierValue(value) {
	return `${value ?? ""}`.trim();
}

export function hasIdentifierText(value) {
	return normalizeIdentifierValue(value) !== "";
}
